/**
 * Parsea números escritos con formato LATAM/ES (1.800 / 8.000) o US (1,800).
 * Evita que parseFloat("1.800") → 1.8 y parseInt("8.000") → 8.
 */
export function parseLocaleNumber(raw: unknown): number {
  if (typeof raw === 'number') return Number.isFinite(raw) ? raw : NaN;
  let s = String(raw ?? '').trim().replace(/\s/g, '');
  if (!s) return NaN;

  // 1.800 / 1.800,5  (miles con punto)
  if (/^\d{1,3}(\.\d{3})+(,\d+)?$/.test(s)) {
    s = s.replace(/\./g, '').replace(',', '.');
  // 1,800 / 1,800.5 (miles con coma)
  } else if (/^\d{1,3}(,\d{3})+(\.\d+)?$/.test(s)) {
    s = s.replace(/,/g, '');
  // 1,8 decimal con coma
  } else if (s.includes(',') && !s.includes('.')) {
    s = s.replace(',', '.');
  }

  const n = Number(s);
  return Number.isFinite(n) ? n : NaN;
}

export function parseLocaleInt(raw: unknown): number {
  const n = parseLocaleNumber(raw);
  return Number.isFinite(n) ? Math.round(n) : NaN;
}

/** Valores de formulario de plan: enteros limpios para inputs. */
export function planFieldString(raw: unknown): string {
  if (raw == null || raw === '') return '';
  const n = parseLocaleNumber(raw);
  if (!Number.isFinite(n)) return '';
  return String(Math.round(n));
}
